import GpsLocationSettings from "./gpsLocationSettingsContainer";
export default GpsLocationSettings;